import { stringify } from 'query-string';
import { entityTypeToApiType } from 'helpers/mapEntityTypes';
import getCountryIds from 'helpers/getCountryIds';
import { MAX_LIMIT } from 'config';

export default getDiscoveryKPICountries;
export { getDiscoveryKPICountries };

/**
 * This URL constructor creates a URL for discovery countries.
 * @param {object} args URL constructor arguments
 * @param {array} args.countryIds Array of country id's to retrieve data for, if omitted data should be returned as broken down (split out) to each country separately
 * @param {boolean} args.download When this parameter is supplied as true the API returns a plain-text csv.
 * @param {array} args.entityIds Array of entity id's to retrieve data for
 * @param {number} args.limit Number of items that should be returned in the response.
 * @param {number} args.offset Offset for the returned selection of the result set.
 * @param {('track'|'artist')} args.entityType Entity type that supports showing data for discovery
 * @param {('countThisWeekToDate'|'countLastWeek')} args.sortBy What metric to sort the list by for discovery
 * @param {('asc'|'desc')} args.sortOrder What order to sort the list by
 * @returns {string} Discovery Countries URL for tracks and artists
 */

interface IProps {
  countryIds?: any;
  download?: boolean;
  entityIds: string[];
  limit?: number;
  offset?: number;
  entityType: 'track' | 'artist';
  sortOrder?: string;
  sortBy?: string;
  countryName?: string;
  region?: string;
  customRegion?: string | string[];
}

function getDiscoveryKPICountries(args: IProps): string {
  const {
    countryIds,
    download,
    entityIds,
    limit = MAX_LIMIT,
    offset,
    entityType,
    sortBy,
    sortOrder,
    countryName,
    region,
    customRegion,
  } = args;

  const apiEntityType = entityTypeToApiType(entityType);

  const params = stringify({
    countryIds: getCountryIds(countryIds, region, customRegion),
    download,
    limit,
    offset,
    sortBy,
    sortOrder,
    countryName,
    regionBreakdown:
      region && (countryIds || customRegion)
        ? 'country'
        : region
        ? 'region'
        : 'country',
  });

  return `/api/discoveries/kpi/${apiEntityType}/${entityIds}/countries${
    params !== '' ? `?${params}` : ''
  }`;
}
